import { call, put, select } from 'redux-saga/effects';
import { urls } from '../../../common/urls';
import { getHttp, getHttpwithtoken, postHttpwithtoken } from '../../../common/ApiCall';
import {
  getFAQDataFailure,
  getFAQDataLoading,
  getFAQDataSuccess,
} from '../../ducks/CustomerSupport';

// Get Customer Support Handler
export function* handlerGetCustomerSupport(action: any): Generator<any, void, any> {
  try {
    yield put(getFAQDataLoading());
    
    // Call GET /api/v1/faqs with authentication
    const fullUrl = `${urls.baseURL}${urls.faq}`;
    console.log('[FAQ Saga] Fetching from:', fullUrl);
    
    const response: any = yield call(getHttpwithtoken, fullUrl);
    
    console.log('[FAQ Saga] Response received:', response);
    console.log('[FAQ Saga] Response type:', typeof response);
    console.log('[FAQ Saga] Is array?', Array.isArray(response));
    
    // Handle different response formats based on API spec
    if (response) {
      // Standard format: { data: [{ question, answer }] }
      if (response.data && Array.isArray(response.data)) {
        console.log('[FAQ Saga] ✓ Found FAQs in response.data:', response.data.length);
        yield put(getFAQDataSuccess(response));
      } 
      // Alternative: Direct array response
      else if (Array.isArray(response)) {
        console.log('[FAQ Saga] ✓ Response is direct array:', response.length);
        yield put(getFAQDataSuccess({ success: true, data: response }));
      }
      // Success flag without data
      else if (response.success === true && response.data) {
        console.log('[FAQ Saga] ✓ Success response with data');
        yield put(getFAQDataSuccess(response));
      }
      // No data found
      else {
        console.warn('[FAQ Saga] Response format not recognized:', response);
        yield put(getFAQDataSuccess({ success: true, data: [] }));
      }
    } else {
      console.error('[FAQ Saga] No response from server');
      yield put(getFAQDataFailure('No response from server'));
    }
  } catch (error: any) {
    console.error('[FAQ Saga] Error occurred:', error);
    console.error('[FAQ Saga] Error message:', error.message);
    console.error('[FAQ Saga] Error response:', error.response);
    yield put(getFAQDataFailure(error.message || 'Failed to get FAQ data'));
  }
}
